var map = {
	"./lesson/config/config.module": [
		"./src/app/routes/live/lesson/config/config.module.ts",
		"default~lesson-config-config-module~live-live-module",
		"lesson-config-config-module"
	],
	"./live/live.module": [
		"./src/app/routes/live/live.module.ts",
		"default~lesson-config-config-module~live-live-module",
		"live-live-module"
	],
	"./pass/pass.module": [
		"./src/app/routes/pass/pass.module.ts",
		"pass-pass-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;